function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import store from '@assets/scripts/store';

var InfoOverlay = /*#__PURE__*/function () {
  function InfoOverlay() {
    _classCallCheck(this, InfoOverlay);
  }

  _createClass(InfoOverlay, null, [{
    key: "register",
    value: function register() {
      var $openOverlay = document.querySelectorAll('[data-info-overlay]');
      var $overlay = document.querySelector('.info-overlay');

      if (!$overlay) {
        return;
      }

      var hasContent = !!String($overlay.querySelector('.content').innerHTML).trim();

      _toConsumableArray($openOverlay).forEach(function (element) {
        element.setAttribute('data-info-overlay', hasContent);
      });

      var toggleHandler = function toggleHandler() {
        if (!$overlay.classList.contains('form') && $overlay.classList.contains('open')) {
          try {
            delete window.digitalData.page.formInfo;
            window.digitalData.page.pageInfo.pageType = 'other';
          } catch (error) {
            console.error(error);
          }
        }

        $overlay.classList.toggle('open');

        if ($overlay.classList.contains('form')) {
          if ($overlay.classList.contains('open')) {
            document.body.classList.add('is-modal-open');
          } else {
            document.body.classList.remove('is-modal-open');
          }
        }

        if ($openOverlay.length) {
          _toConsumableArray($openOverlay).forEach(function (element) {
            element.classList.toggle('open');
          });
        }
      };

      setTimeout(function () {
        $openOverlay = document.querySelectorAll('[data-info-overlay]');

        if ($openOverlay.length && hasContent) {
          _toConsumableArray($openOverlay).forEach(function (element) {
            element.classList.add('test');
            element.addEventListener('click', toggleHandler, false);
          });
        }
      }, 0);

      if (hasContent) {
        store.dispatch('forms/replaceMarkupVariables', $overlay);
        $overlay.addEventListener('click', function (event) {
          if (event.target.classList.contains('close') || event.target.parentNode.classList.contains('close')) {
            toggleHandler();
          }
        }, false);

        if (window.location.href.includes('thanks.html')) {
          store.dispatch('forms/analytics');
        }
      }
    }
  }]);

  return InfoOverlay;
}();

export default InfoOverlay;